const Constant = {
    validationRequired: 'VALIDATION_REQUIRED',
    validationEmail: 'VALIDATION_EMAIL',
    validationMobile: 'VALIDATION_MOBILE',
    validationPersonId: 'VALIDATION_PERSON_ID',
    validationCodeNumber: 'VALIDATION_CODE_NUMBER',
    validationPassword: 'VALIDATION_PASSWORD',

    typeCheckbox: 'checkbox',
    typeRadio: 'radio',
    typeText: 'text',
    typeTel: 'tel',
    typePassword: 'password',
    typeEmail: 'email',
    typeHidden: 'hidden',
    typeElement: 'element',

    typeFieldButtonPasswordReveal: 'FIELD_BUTTON_PASSWORD_REVEAL',

    avtaleOTPwrongCode: 'WRONG_OTP_CODE',
    avtaleOTPwrongPassword: 'WRONG_PASSWORD',
    avtaleOTPinvalid: 'NO_BANKID_OR_OTP_VERIFICATION_FAILED',
    avtaleOTPnoOrder: 'NO_BANKID_ORDERED',
};
export default Constant;
